/**
 * Gestione Pratiche API
 * Servizi per la gestione della piattaforma Gestione Pratiche
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ComunicazioneDTO } from '../model/comunicazioneDTO';
import { ElementoGraduatoriaDTO } from '../model/elementoGraduatoriaDTO';
import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { GenericResponseDTO } from '../model/genericResponseDTO';
import { InlineResponse500 } from '../model/inlineResponse500';
import { LimiteAssegnazione } from '../model/limiteAssegnazione';
import { ModalitaEstensione } from '../model/modalitaEstensione';
import { TipoPratica } from '../model/tipoPratica';
import { TipoPraticaDTO } from '../model/tipoPraticaDTO';
import { TipoPraticaPatchDTO } from '../model/tipoPraticaPatchDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TipoPraticaControllerService {

    protected basePath = 'http://comune.southengineering.it/gestione-pratiche';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Consente di aggiungere un nuovo tipo pratica
     * 
     * @param body 
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addTipoPratica(body: TipoPraticaDTO, id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<TipoPratica>;
    public addTipoPratica(body: TipoPraticaDTO, id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TipoPratica>>;
    public addTipoPratica(body: TipoPraticaDTO, id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TipoPratica>>;
    public addTipoPratica(body: TipoPraticaDTO, id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addTipoPratica.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling addTipoPratica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TipoPratica>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/tipo_pratica`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di annullare la graduatoria
     * 
     * @param id_slug_comune 
     * @param codiceTipoPratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public annullaGraduatoria(id_slug_comune: string, codiceTipoPratica: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public annullaGraduatoria(id_slug_comune: string, codiceTipoPratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public annullaGraduatoria(id_slug_comune: string, codiceTipoPratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public annullaGraduatoria(id_slug_comune: string, codiceTipoPratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling annullaGraduatoria.');
        }

        if (codiceTipoPratica === null || codiceTipoPratica === undefined) {
            throw new Error('Required parameter codiceTipoPratica was null or undefined when calling annullaGraduatoria.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/tipo_pratica/${encodeURIComponent(String(codiceTipoPratica))}/annullaGraduatoria`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di confermare la graduatoria. In caso di redistribuzione dei soldi verrà eseguita anch&#x27;essa
     * 
     * @param id_slug_comune 
     * @param codiceTipoPratica 
     * @param limiteAssegnazione 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public confermaGraduatoria(id_slug_comune: string, codiceTipoPratica: string, limiteAssegnazione: LimiteAssegnazione, observe?: 'body', reportProgress?: boolean): Observable<Array<ElementoGraduatoriaDTO>>;
    public confermaGraduatoria(id_slug_comune: string, codiceTipoPratica: string, limiteAssegnazione: LimiteAssegnazione, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ElementoGraduatoriaDTO>>>;
    public confermaGraduatoria(id_slug_comune: string, codiceTipoPratica: string, limiteAssegnazione: LimiteAssegnazione, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ElementoGraduatoriaDTO>>>;
    public confermaGraduatoria(id_slug_comune: string, codiceTipoPratica: string, limiteAssegnazione: LimiteAssegnazione, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling confermaGraduatoria.');
        }

        if (codiceTipoPratica === null || codiceTipoPratica === undefined) {
            throw new Error('Required parameter codiceTipoPratica was null or undefined when calling confermaGraduatoria.');
        }

        if (limiteAssegnazione === null || limiteAssegnazione === undefined) {
            throw new Error('Required parameter limiteAssegnazione was null or undefined when calling confermaGraduatoria.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (limiteAssegnazione !== undefined && limiteAssegnazione !== null) {
            queryParameters = queryParameters.set('limiteAssegnazione', <any>limiteAssegnazione);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ElementoGraduatoriaDTO>>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/tipo_pratica/${encodeURIComponent(String(codiceTipoPratica))}/confermaGraduatoria`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di confermare la graduatoria. In caso di redistribuzione dei soldi verrà eseguita anch&#x27;essa
     * 
     * @param id_slug_comune 
     * @param codiceTipoPratica 
     * @param modalitaEstensione 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public estendiGraduatoria(id_slug_comune: string, codiceTipoPratica: string, modalitaEstensione: ModalitaEstensione, observe?: 'body', reportProgress?: boolean): Observable<Array<ElementoGraduatoriaDTO>>;
    public estendiGraduatoria(id_slug_comune: string, codiceTipoPratica: string, modalitaEstensione: ModalitaEstensione, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ElementoGraduatoriaDTO>>>;
    public estendiGraduatoria(id_slug_comune: string, codiceTipoPratica: string, modalitaEstensione: ModalitaEstensione, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ElementoGraduatoriaDTO>>>;
    public estendiGraduatoria(id_slug_comune: string, codiceTipoPratica: string, modalitaEstensione: ModalitaEstensione, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling estendiGraduatoria.');
        }

        if (codiceTipoPratica === null || codiceTipoPratica === undefined) {
            throw new Error('Required parameter codiceTipoPratica was null or undefined when calling estendiGraduatoria.');
        }

        if (modalitaEstensione === null || modalitaEstensione === undefined) {
            throw new Error('Required parameter modalitaEstensione was null or undefined when calling estendiGraduatoria.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (modalitaEstensione !== undefined && modalitaEstensione !== null) {
            queryParameters = queryParameters.set('modalitaEstensione', <any>modalitaEstensione);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ElementoGraduatoriaDTO>>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/tipo_pratica/${encodeURIComponent(String(codiceTipoPratica))}/estendiGraduatoria`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di visualizzare tutti i tipi pratica
     * 
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAll1(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TipoPratica>>;
    public getAll1(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TipoPratica>>>;
    public getAll1(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TipoPratica>>>;
    public getAll1(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getAll1.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<TipoPratica>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/tipo_pratica`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di visualizzare tutti i tipi pratica
     * 
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllPublic(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TipoPratica>>;
    public getAllPublic(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TipoPratica>>>;
    public getAllPublic(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TipoPratica>>>;
    public getAllPublic(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getAllPublic.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<TipoPratica>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/tipo_pratica/public`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di avere la graduatoria. Se confermata verrà prelevata dal db, altrimenti calcolata onair
     * 
     * @param id_slug_comune 
     * @param codiceTipoPratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGraduatoria(id_slug_comune: string, codiceTipoPratica: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ElementoGraduatoriaDTO>>;
    public getGraduatoria(id_slug_comune: string, codiceTipoPratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ElementoGraduatoriaDTO>>>;
    public getGraduatoria(id_slug_comune: string, codiceTipoPratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ElementoGraduatoriaDTO>>>;
    public getGraduatoria(id_slug_comune: string, codiceTipoPratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getGraduatoria.');
        }

        if (codiceTipoPratica === null || codiceTipoPratica === undefined) {
            throw new Error('Required parameter codiceTipoPratica was null or undefined when calling getGraduatoria.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ElementoGraduatoriaDTO>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/tipo_pratica/${encodeURIComponent(String(codiceTipoPratica))}/graduatoria`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di visualizzare il dettaglio di un tipo pratica
     * 
     * @param id_slug_comune 
     * @param codiceTipoPratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTipoPratica(id_slug_comune: string, codiceTipoPratica: string, observe?: 'body', reportProgress?: boolean): Observable<TipoPratica>;
    public getTipoPratica(id_slug_comune: string, codiceTipoPratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TipoPratica>>;
    public getTipoPratica(id_slug_comune: string, codiceTipoPratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TipoPratica>>;
    public getTipoPratica(id_slug_comune: string, codiceTipoPratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getTipoPratica.');
        }

        if (codiceTipoPratica === null || codiceTipoPratica === undefined) {
            throw new Error('Required parameter codiceTipoPratica was null or undefined when calling getTipoPratica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TipoPratica>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/tipo_pratica/${encodeURIComponent(String(codiceTipoPratica))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di visualizzare il dettaglio di un tipo pratica
     * 
     * @param id_slug_comune 
     * @param codiceTipoPratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTipoPraticaPublic(id_slug_comune: string, codiceTipoPratica: string, observe?: 'body', reportProgress?: boolean): Observable<TipoPratica>;
    public getTipoPraticaPublic(id_slug_comune: string, codiceTipoPratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TipoPratica>>;
    public getTipoPraticaPublic(id_slug_comune: string, codiceTipoPratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TipoPratica>>;
    public getTipoPraticaPublic(id_slug_comune: string, codiceTipoPratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getTipoPraticaPublic.');
        }

        if (codiceTipoPratica === null || codiceTipoPratica === undefined) {
            throw new Error('Required parameter codiceTipoPratica was null or undefined when calling getTipoPraticaPublic.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TipoPratica>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/tipo_pratica/${encodeURIComponent(String(codiceTipoPratica))}/public`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di inviare delle comunicazioni relative all&#x27;esito della graduatoria.
     * 
     * @param body 
     * @param id_slug_comune 
     * @param codiceTipoPratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public inviaComunicazioniGraduatoria(body: ComunicazioneDTO, id_slug_comune: string, codiceTipoPratica: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public inviaComunicazioniGraduatoria(body: ComunicazioneDTO, id_slug_comune: string, codiceTipoPratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public inviaComunicazioniGraduatoria(body: ComunicazioneDTO, id_slug_comune: string, codiceTipoPratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public inviaComunicazioniGraduatoria(body: ComunicazioneDTO, id_slug_comune: string, codiceTipoPratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling inviaComunicazioniGraduatoria.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling inviaComunicazioniGraduatoria.');
        }

        if (codiceTipoPratica === null || codiceTipoPratica === undefined) {
            throw new Error('Required parameter codiceTipoPratica was null or undefined when calling inviaComunicazioniGraduatoria.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<string>>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/tipo_pratica/${encodeURIComponent(String(codiceTipoPratica))}/inviaComunicazioniGraduatoria`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di modificare alcuni parametri di un tipo pratica
     * 
     * @param body 
     * @param id_slug_comune 
     * @param codiceTipoPratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchTipoPratica(body: TipoPraticaPatchDTO, id_slug_comune: string, codiceTipoPratica: string, observe?: 'body', reportProgress?: boolean): Observable<TipoPratica>;
    public patchTipoPratica(body: TipoPraticaPatchDTO, id_slug_comune: string, codiceTipoPratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TipoPratica>>;
    public patchTipoPratica(body: TipoPraticaPatchDTO, id_slug_comune: string, codiceTipoPratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TipoPratica>>;
    public patchTipoPratica(body: TipoPraticaPatchDTO, id_slug_comune: string, codiceTipoPratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling patchTipoPratica.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling patchTipoPratica.');
        }

        if (codiceTipoPratica === null || codiceTipoPratica === undefined) {
            throw new Error('Required parameter codiceTipoPratica was null or undefined when calling patchTipoPratica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TipoPratica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/tipo_pratica/${encodeURIComponent(String(codiceTipoPratica))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di modificare un tipo pratica
     * 
     * @param body 
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTipoPratica(body: TipoPraticaDTO, id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<TipoPratica>;
    public updateTipoPratica(body: TipoPraticaDTO, id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TipoPratica>>;
    public updateTipoPratica(body: TipoPraticaDTO, id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TipoPratica>>;
    public updateTipoPratica(body: TipoPraticaDTO, id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateTipoPratica.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling updateTipoPratica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TipoPratica>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/tipo_pratica`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
